import actions from './actions';

const initState = {
    data: []
};

export default function ProjectCommentReducer(state = initState, action) {
    switch (action.type) {
        case actions.ProjectComment_SUCCESS:
            return {
                ...state,
                data: action.payload.data
            };
        default:
            return state;
    }
}
